/** Token-adaptive mint presets — amounts sensible for each token's value. */
export const TOKEN_MINT_PRESETS: Record<string, string[]> = {
  USDC: ["100", "1000", "10000", "100000"],
  USDT: ["100", "1000", "10000", "100000"],
  DAI: ["100", "1000", "10000", "100000"],
  WBTC: ["0.01", "0.1", "1", "10"],
};
export const DEFAULT_MINT_PRESETS = ["100", "1000", "10000", "100000"];

/** DeFi address presets for impersonation. */
export const DEFI_ADDRESS_PRESETS = [
  {
    label: "Vitalik.eth",
    address: "0xd8dA6BF26964aF9D7eEd9e03E53415D37aA96045",
  },
  {
    label: "Uniswap Treasury",
    address: "0x1a9C8182C09F50C8318d769245beA52c32BE35BC",
  },
  {
    label: "USDC Whale",
    address: "0x55FE002aefF02F77364de339a1292923A15844B8",
  },
];
